

















import {Component, Vue, Watch} from "vue-property-decorator";
import {PickingListDeliveryEmployeeParams} from "../../../params";
import MillisecondDatePicker from "../../../../../shared/components/MillisecondDatePicker/index.vue";
import EmployeeSelector from "../../../../../shared/components/EmployeeSelector/index.vue";
import {EmployeeType} from "@/enums/type";
import {PickingListDeliveryStore} from "../../../store";
import { debounce } from 'lodash';
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";

@Component({
    name: "PLDeliverySearchEmployee",
    components: {AInputBarCode, EmployeeSelector, MillisecondDatePicker}
})
export default class extends Vue {
    EmployeeType = EmployeeType;
    search = new PickingListDeliveryEmployeeParams();

    @Watch("search", { immediate: false, deep: true })
    onSearch(val: any, oldVal: any) {
        this.handleChangeSearch(val);
    }

    handleChangeSearch = debounce((val: any) => {
        PickingListDeliveryStore.updatePickingListDeliveryParams({ ...PickingListDeliveryStore.params, ...val });
        PickingListDeliveryStore.listPickingListDeliveryForEmployee({...PickingListDeliveryStore.params, page: 1});
    }, 500)

    onEnterPickingListCode(evt: any) {
        this.$set(this.search, 'code', evt?.target?.value || undefined);
    }
}
